var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-hero",style:(("" + _vm.image + _vm.color))},[_c('v-container',{class:("d-flex align-center app-hero-content " + (_vm.hasMask && 'has-mask'))},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }